import React, { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";

import { useApp } from "@/context/AppContext";
import FixedHeader from "@/components/site/FixedHeader";
import Hero from "@/components/site/Hero";
import Ethos from "@/components/site/Ethos";
import CrmExample from "@/components/site/CrmExample";
import Packages from "@/components/site/Packages";
import Industries from "@/components/site/Industries";
import Process from "@/components/site/Process";
import OrangeCare from "@/components/site/OrangeCare";
import Portfolio from "@/components/site/Portfolio";
import CrmDiscovery from "@/components/site/CrmDiscovery";
import HomeOptimise from "@/components/site/HomeOptimise";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import OrangeOptimisePromoModal from "@/components/site/OrangeOptimisePromoModal";

function Shell() {
  const { dir } = useApp();
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App relative text-black" dir={dir}>
      <div aria-hidden className="fixed inset-0 -z-10" style={{ background: "radial-gradient(ellipse 90% 80% at 58% 45%, #FFB347 0%, #FF8A2E 30%, #FF7A00 55%, #FF6A00 80%, #D94C00 100%)" }} />
      <div aria-hidden className="fixed inset-0 -z-10 pointer-events-none" style={{ background: "radial-gradient(ellipse 120% 100% at 50% 50%, transparent 55%, rgba(90,25,0,0.28) 100%)" }} />
      <div aria-hidden className="fixed inset-0 -z-10 pointer-events-none opacity-[0.07] mix-blend-overlay" style={{ backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.55 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")", backgroundSize: "180px 180px" }} />
      <Toaster theme="light" position="top-center" richColors toastOptions={{ style: { background: "#fff", border: "1px solid rgba(0,0,0,0.1)", color: "#000" } }} />
      <FixedHeader />
      <main className="relative pt-[204px] lg:pt-[132px]">
        <Hero /><Ethos /><CrmExample /><Packages /><Industries /><Process /><HomeOptimise /><OrangeCare /><Portfolio /><CrmDiscovery />
      </main>
      <Footer />
      <WhatsAppFab />
      <OrangeOptimisePromoModal />
    </div>
  );
}

export default function PublicSite() {
  // Phase 3I.3N (Issue 4) — Website Pitch CTA lands here with
  // /?ref=website-pitch#enquire. Because the page's real content loads
  // AFTER the initial paint (Hero, sections, etc.), a native browser
  // hash-scroll often fires before the enquiry section exists. Wait for
  // it, then smooth-scroll with the sticky-header offset already
  // configured in index.css (`scroll-margin-top: var(--sticky-header)`).
  React.useEffect(() => {
    const hash = window.location.hash;
    if (hash !== "#enquire" && hash !== "#discovery") return;
    let tries = 0;
    const maxTries = 40; // ~4s @ 100ms
    const timer = setInterval(() => {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        clearInterval(timer);
      } else if (++tries >= maxTries) {
        clearInterval(timer);
      }
    }, 100);
    return () => clearInterval(timer);
  }, []);
  return <Shell />;
}
